'use strict';
/*!
 * for Campus Map Block
 *
 * @package tokai-univ
 * @deps jquery, leaflet
 */

const $ = jQuery;

let campusMapImgWidth;
let campusMapImgHeight;

$( window ).on( 'load', function () {
	const campusMap = $( '.js-campus-map' );
	if ( campusMap.length ) {
		campusMap.each( function ( index ) {
			//img
			const campusMapImgElm = $( this ).find( '.js-campus-map-img' );
			campusMapImgElm.attr( 'id', 'campus-map-img-' + index );
			const campusMapImgPath = campusMapImgElm.attr( 'src' );
			campusMapImgWidth = campusMapImgElm.width();
			campusMapImgHeight = campusMapImgElm.height();

			//box
			const campusMapBoxElm = $( this ).find( '.js-campus-map-box' );
			campusMapBoxElm.attr( 'id', 'campus-map-box-' + index );
			const targetCmBoxId = 'campus-map-box-' + index;

			const image = {
				url: campusMapImgPath,
				width: campusMapImgWidth,
				height: campusMapImgHeight,
			};

			const map = L.map( targetCmBoxId, {
				maxZoom: 5,
				minZoom: 1,
				zoom: 1,
				dragging: true, //drag
				zoomControl: false, //default zoom control off
				scrollWheelZoom: false, //mouse wheel
				doubleClickZoom: false, //double click zoom
				boxZoom: false, //shift key dragging
				attributionControl: false, //hide leaflet credit
			} );

			const imageBounds = L.latLngBounds(
				map.unproject( [ 0, campusMapImgHeight ] ),
				map.unproject( [ campusMapImgWidth, 0 ] )
				//[0, 0],
				//[campusMapImgHeight / 2, campusMapImgWidth / 2]
			);

			L.imageOverlay( image.url, imageBounds ).addTo( map );
			L.control.zoom( { position: 'bottomright' } ).addTo( map ); //add new zoom control
			map.fitBounds( imageBounds );
			//map.setMaxBounds( imageBounds.pad( 0.5 ) );
			map.setMaxBounds( new L.LatLngBounds( [ campusMapImgHeight * 2 ], [ campusMapImgWidth / 2 ] ) );

		} );
	}
} );
